<template>
  <div>
    <!-- start wrapper -->
    <div class="login__wrapper">
      <!-- start container -->
      <div class="login__container">
        <div class="row">
          <!-- left side: end -->
          <div
            class="
              col-12 col-sm-12 col-xs-12 col-md-6 col-lg-6 col-xl-6
              login__loginCard--leftSide
            "
          >
            <!-- left side: part 1 start -->
            <div
              class="login-form"
              v-if="!showResetPassword && !showClientBlock"
            >
              <h2 class="login__maintitle--text" v-if="welcome_note">
                {{ welcome_note }}
              </h2>
              <div
                class="
                  alert alert-success
                  login__card--notify-bar
                  success-account
                "
                role="alert"
                id="send-information-success"
                style="display: none"
              >
                We have successfully created your account. To log in, use
                Student number with password
              </div>
              <div
                class="alert alert-danger login__card--notify-bar"
                role="alert"
                id="fail-login"
                style="display: none"
              >
                <strong>Oh snap!</strong> Change a few things up and try
                submitting again.
              </div>

              <form class="login__form" @submit="formSubmit">
                <div class="inputBox">
                  <input
                    type="text"
                    v-model="username"
                    name="username"
                    id="username"
                    autocomplete="off"
                    required
                  />
                  <label>EMAIL OR USERNAME</label>
                </div>

                <div class="inputBox">
                  <input
                    :type="passwordFieldType"
                    v-model="password"
                    name="password"
                    id="password"
                    required
                  />

                  <span
                    class="login__password--show--hide"
                    @click="switchVisibility"
                  >
                    <span v-if="displayPasswordText" class="">
                      <img
                        src="https://img.icons8.com/ios/22/000000/visible--v1.png"
                        style="opacity: 0.6"
                      />
                    </span>
                    <span v-else>
                      <img
                        src="https://img.icons8.com/ios/22/000000/hide.png"
                        style="opacity: 0.6"
                      />
                    </span>
                  </span>

                  <label>PASSWORD</label>
                </div>

                <div class="text-right mb-4">
                  <a
                    class="login__forget-pwd"
                    href="javascript:;"
                    id="forget_password"
                    @click="showResetPassword = true"
                    >Forgot Password?</a
                  >
                </div>
                <div
                  v-if="!showSocialSignup"
                  class="login__empty--box--one"
                ></div>

                <div>
                  <button
                    class="btn btn__login"
                    href="javascript:;"
                    id="submit"
                  >
                    Login
                  </button>
                  <div id="loadClientModal"></div>
                </div>
                <div
                  v-if="!showSocialSignup"
                  class="login__empty--box--two"
                ></div>
              </form>
            </div>
            <!-- left side: part 1 end -->

            <!-- left side: part 2 start -->
            <div
              class="login-form"
              v-if="showResetPassword && !showClientBlock"
            >
              <h2 class="login__maintitle--text">Reset your password</h2>
              <div
                class="alert alert-success notify-bar"
                id="submit_success"
                v-if="successMessage && email_has_institute.length > 0"
              >
                Cool! password instructions have been sent to your account
                <!-- <li
                  v-for="(insti, index) in email_has_institute"
                  :key="index"
                >
                  {{ insti }}
                </li> -->
              </div>
              <div
                class="alert alert-danger notify-bar"
                id="submit_error"
                v-if="failMessage"
              >
                {{reseterorr}}
              </div>
              <div
                class="alert alert-danger notify-bar"
                id="submit_error"
                v-if="email_not_institute.length > 0"
              >
                Please contact the following institution(s) to reset your
                password.
                <li v-for="(inst, index) in email_not_institute" :key="index">
                  {{ inst }}
                </li>
              </div>
              <form class="login__form" id="resetPasswordForm">
                <div class="inputBox">
                  <input
                    type="text"
                    name="phone_email"
                    v-model="phone_email"
                    id="m_email"
                    autocomplete="off"
                    required
                  />
                  <label>YOUR EMAIL OR USERNAME</label>
                </div>

                <div class="row mt-2">
                  <div class="col-12">
                    <button
                      class="btn btn__login--request--reset-pwd mt-2 mb-3"
                      id="forget_password_submit"
                      @click.prevent="submitResetForm"
                    >
                      Request
                    </button>
                    <button
                      class="btn btn__login--login--back"
                      id="forget_password_cancel"
                      @click="showResetPassword = false"
                    >
                      Goto Login
                    </button>
                  </div>
                </div>
                <div
                  v-if="!showSocialSignup"
                  class="login__empty--box--three"
                ></div>
              </form>
            </div>
            <!-- left side: part 2 end -->

            <!-- left side: part 3 start -->
            <div class="login-form" v-if="showClientBlock && !showSocialSignup">
              <h2 class="login__maintitle--text">
                Enter the Institute key <br />to Sign up
              </h2>
              <div
                class="alert alert-success notify-bar"
                id="social_success"
                v-if="successMessage"
              >
                Cool! successfully registered.
              </div>
              <div
                class="alert alert-danger notify-bar"
                id="social_error"
                v-if="failMessage"
              >
                <ul>
                  <li v-for="(error, index) in social_error" :key="index">
                    {{ error }}
                  </li>
                </ul>
              </div>

              <form id="social_login_form" class="login__form">
                <div class="inputBox">
                  <input
                    type="text"
                    name="institute_key"
                    v-model="institute_key"
                    id="institute_key"
                    autocomplete="off"
                    required
                  />
                  <label>Student number / Username</label>
                </div>

                <div class="row mt-2">
                  <div class="col-12">
                    <button
                      id="social_login_form_submit"
                      class="btn btn__login--request--reset-pwd mt-2 mb-3"
                      @click.prevent="registerUserBySocialID"
                    >
                      Signup
                    </button>
                    <button
                      class="btn btn__login--login--back"
                      id="social_login_form_cancel"
                      @click.prevent="showLoginForms"
                    >
                      Goto Login
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <!-- left side: part 3 end -->

            <!-- social login: start -->
            <input
              type="hidden"
              name="showSocialwrapper"
              id="showSocialwrapper"
              value="false"
            />
            <div v-if="showSocialSignup">
              <h5 class="separator mt-4">
                <span>&nbsp;</span>or<span>&nbsp;</span>
              </h5>

              <div class="text-center mt-4">
                <SocialLogin></SocialLogin>
              </div>
            </div>
            <!-- social login: end -->
          </div>
          <!-- left side: end -->

          <!-- Right side: start -->
          <div
            class="p-0 col-12 col-sm-12 col-xs-12 col-md-6 col-lg-6 col-xl-6"
          >
            <img
              :src="login_side_background_img"
              class="col-right__oraganization--image"
              alt=""
            />
          </div>
          <!-- Right side: end -->
        </div>
      </div>
      <!-- end container -->

      <!-- slogan text -->
      <div class="credit" v-if="organization_slogan">
        {{ organization_slogan }}
      </div>
      <!-- Visit WEb button: visible in mobile view -->
      <div class="login__btn-site--mobile">
        <a
          class="login__desktop--visit--mobile--btn"
          :href="web_site_url"
          target="_blank"
          type="button"
        >
          Visit Website
        </a>
      </div>
    </div>
    <!-- end wrapper -->

    <div class="loader_wrapper mx-auto" v-if="isLoading">
      <div class="loader_block">
        <loading
          :active.sync="isLoading"
          :color="highlight_color"
          :loader="'spinner'"
          :can-cancel="false"
          :is-full-page="false"
        ></loading>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal modern fade"
      id="school-login-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered mx-auto" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Institute Login Selection
            </h5>
            <img
              class="close"
              src="/media/icons/close.png"
              data-dismiss="modal"
              aria-label="Close"
              width="53px"
            />
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div
                  class="alert alert-danger notify-bar mb-5"
                  role="alert"
                  id="fail-login-institute"
                  style="display: none"
                ></div>
                <div class="middle-login">
                  <a
                    v-for="(client, index) in clientList"
                    :key="index"
                    href="#"
                    @click="loginFromClient(client)"
                    class="school-login"
                  >
                    <div class="logo-inner">
                      <img src="media/icons/school.png" />
                    </div>
                    <div class="school-name">{{ client.company_name }}</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import SocialLogin from "@/components/template/Socialsignup";
import "vue-loading-overlay/dist/vue-loading.css";

var Config = require("../router/Config");
var $ = require("jquery");
var Cookies = require("vue-cookies");
var Login = {
  name: "login",
  props: ["authenticated"],

  components: { Loading, SocialLogin },
  data() {
    return {
      username: "",
      password: "",
      passwordFieldType: "password",
      displayPasswordText: true,
      showResetPassword: false,
      successMessage: false,
      failMessage: false,
      phone_email: "",
      logo_url: "",
      loging_background: Config.LOGIN_BACKGROUND(),
      client_name: Config.Client_name(),
      login_subtitle: Config.loginSubtitle(),
      showClientBlock: false,
      institute_key: "",
      socialLoginData: [],
      isLoading: false,
      social_error: [],
      showSocialSignup: true,
      clientList: [],
      themeColor: "",
      organization_slogan: "",
      welcome_note: "",
      highlight_color: "",
      login_side_background_img: "",
      web_site_url: "",
      email_has_institute: [],
      email_not_institute: [],
      reseterorr: "",
    };
  },
  mounted() {
    var self = this;
    if (document.location.origin !== "https://app.webcolms.com") {
      self.showSocialSignup = false;
    }
    this.getLogo();
    setInterval(function () {
      if ($("#showSocialwrapper").val() === "true") {
        self.isLoading = true;
        $("#showSocialwrapper").val(false);
        self.socialLoginData = window.socialLoginData;
        self.axios
          .post(Config.API_URL + "/api/fe/auth/checksocialid", {
            id: self.socialLoginData.id,
          })
          .then((response) => {
            var result = response.data;
            console.log(result);
            self.isLoading = false;
            if (result.res === "0") {
              self.showClientBlock = true;
              self.showSocialSignup = false;
            } else if (result.res === "1") {
              self.$emit("authenticated", true);
              $("#fail-login").hide();

              Cookies.set("accessToken", result.data);
              Cookies.set("userId", result.id);
              Cookies.set("clientId", result.clientId);
              Cookies.set("firstName", result.firstName);
              Cookies.set("lastName", result.lastName);
              Cookies.set("student_number", result.student_number);
              Cookies.set("email", result.email);
              Cookies.set("profileImage", result.profileImage);
              Cookies.set("usertype", result.userType);
              Cookies.set("userDetail", result.user);
              Cookies.set("company", result.companyData);

              if (result.isMultiClient) {
                self.clientList = result.clientList;
                $("#loadClientModal").append(
                  '<div class="load-client-modal" data-toggle="modal" data-target="#school-login-modal"></div>'
                );
                $(".load-client-modal").click();
              } else {
                self.$emit("authenticated", true);
                Cookies.set("userPermissions", result.userPermissions);
                Cookies.set("clientId", result.clientId);
                Cookies.set("company", result.companyData);
                Cookies.set("studentId", result.user.student[0].id);
                Cookies.set(
                  "student_number",
                  result.user.student[0].student_number
                );
                self.$router.replace({ name: "dashboard" });
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }, 1000);
    window.onpopstate = (event) => {
      var appos = Cookies.get("appos");
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/auth/removeSession?token=" +
            Cookies.get("accessToken"),
          {
            deviceSessionId: Cookies.get("deviceSessionId"),
          }
        )
        .then((response) => {
          var allCookies = Cookies.keys();
          allCookies.forEach((items) => {
            Cookies.remove(items);
          });
          clearInterval(this.sessionInterval);
          this.$emit("authenticated", false);
          if (this.isMobile) {
            this.logoutFromMobileApp(appos, "");
          }
          location.reload();
        })
        .catch(function (error) {
          console.log(error);
        });
      this.$router.replace({ name: "login" });
    };
  },
  methods: {
    formSubmit: function (e) {
      e.preventDefault();
      this.isLoading = true;
      this.axios
        .post(Config.API_URL + "/api/fe/auth/login1", {
          username: this.username,
          password: this.password,
        })
        .then((response) => {
          this.isLoading = false;
          var result = response.data;
          if (result.res === "1") {
            if (result.status === 1) {
              $("#fail-login").hide();
              $("#fail-login-institute").hide();
              // console.log(result)
              Cookies.set("accessToken", result.data);
              Cookies.set("userId", result.id);
              Cookies.set("firstName", result.firstName);
              Cookies.set("lastName", result.lastName);
              Cookies.set("email", result.email);
              Cookies.set("student_number", result.student_number);
              Cookies.set("profileImage", result.profileImage);
              Cookies.set("usertype", result.userType);
              Cookies.set("userDetail", result.user);

              if (result.isMultiClient) {
                this.clientList = result.clientList;
                $("#loadClientModal").append(
                  '<div class="load-client-modal" data-toggle="modal" data-target="#school-login-modal"></div>'
                );
                $(".load-client-modal").click();
              } else {
                this.$emit("authenticated", true);
                Cookies.set("userPermissions", result.userPermissions);
                Cookies.set("clientId", result.clientId);
                Cookies.set("studentId", result.user.student[0].id);
                Cookies.set(
                  "student_number",
                  result.user.student[0].student_number
                );
                Cookies.set("company", result.companyData);
                console.log(
                  "login Cookie set to : " + Cookies.get("redirectUrl")
                );
                this.checkSessionForUser();
              }
            } else {
              $("#fail-login").text(
                "Your account has been disabled please contact administrator"
              );
              $("#fail-login").show();
            }
          } else if (result.res === "2") {
            if (result.status === 1) {
              $("#fail-login").hide();
              Cookies.set("accessToken", result.data);
              Cookies.set("usertype", result.userType);
              Cookies.set("userId", result.id);
              this.$router.replace({ name: "force_reset" });
            } else {
              $("#fail-login").text(
                "Your account has been disabled please contact administrator"
              );
              $("#fail-login").show();
            }
          } else {
            $("#fail-login").text(result.data);
            $("#fail-login").show();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loginFromClient: function (studentClientData) {
      if (studentClientData.student_active_flag === 0) {
        // $('#fail-login').text('Your student account for this Institute has been disabled, please contact administrator')
        // $('#fail-login').show()
        $("#fail-login-institute").text(
          "Your student account for this Institute has been disabled, please contact administrator"
        );
        $("#fail-login-institute").show();
      } else if (studentClientData.client_status === 0) {
        // $('#fail-login').text('Sorry, Your Institute has been inactivated by the system. Please contact Institute Administration for details.')
        // $('#fail-login').show()
        $("#fail-login-institute").text(
          "Sorry, Your Institute has been inactivated by the system. Please contact Institute Administration for details."
        );
        $("#fail-login-institute").show();
      } else {
        this.$emit("authenticated", true);
        Cookies.set("clientId", studentClientData.client_id);
        Cookies.set("userPermissions", studentClientData.userPermissions);
        Cookies.set("studentId", studentClientData.student_id);
        Cookies.set("student_number", studentClientData.student_number);
        Cookies.set("firstName", studentClientData.first_name);
        Cookies.set("lastName", studentClientData.last_name);
        Cookies.set("company", studentClientData.companyData);
        this.checkSessionForUser();
      }
    },
    submitResetForm: function () {
      if (this.phone_email !== "") {
        this.axios
          .post(Config.API_URL + "/api/fe/password-reset-request", {
            phone_email: this.phone_email,
          })
          .then((response) => {
            var result = response.data;
            if (result.res === "1") {
              this.email_not_institute = response.data.data.email_not_institute;
              this.email_has_institute = response.data.data.email_has_institute;
              this.failMessage = false;
              this.successMessage = true;
              this.phone_email = "";
            } else {
              this.failMessage = true;
              this.successMessage = false;
              this.reseterorr = result.msg;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.failMessage = true;
        this.successMessage = false;
      }
    },
    showLoginForms: function () {
      location.reload();
    },
    registerUserBySocialID: function () {
      this.social_error = [];
      if (this.institute_key !== "") {
        this.isLoading = true;
        this.axios
          .post(Config.API_URL + "/api/fe/auth/registerbysocialid", {
            institute_key: this.institute_key,
            facebook_data: this.socialLoginData,
          })
          .then((response) => {
            var result = response.data;
            console.log("registerUserBySocialID");
            console.log(result);
            this.isLoading = false;
            if (result.res === "1") {
              this.failMessage = false;
              this.successMessage = true;
              this.institute_key = "";

              this.$emit("authenticated", true);
              $("#fail-login").hide();

              Cookies.set("accessToken", result.data);
              Cookies.set("userId", result.id);
              Cookies.set("clientId", result.clientId);
              Cookies.set("firstName", result.firstName);
              Cookies.set("lastName", result.lastName);
              Cookies.set("email", result.email);
              Cookies.set("profileImage", result.profileImage);
              Cookies.set("userPermissions", result.userPermissions);
              Cookies.set("usertype", result.userType);
              Cookies.set("userDetail", result.user);
              Cookies.set("studentId", result.user.student[0].id);
              Cookies.set("company", result.companyData);
              this.checkSessionForUser();
            } else {
              this.social_error = result.msg;
              this.failMessage = true;
              this.successMessage = false;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.social_error.push("Please enter valid Institute Key");
        this.failMessage = true;
        this.successMessage = false;
      }
    },
    checkSessionForUser: function () {
      console.log(navigator);
      const browserData = {
        platform: navigator.platform,
        vendor: navigator.vendor,
        userAgent: navigator.userAgent,
      };

      this.axios
        .post(Config.API_URL + "/api/fe/auth/checkSessionForUser", {
          user_id: Cookies.get("userId"),
          client_id: Cookies.get("clientId"),
          session_token:
            typeof Cookies.get("deviceSessionToken") !== "undefined"
              ? Cookies.get("deviceSessionToken")
              : null,
          browser_data: browserData,
        })
        .then((response) => {
          var result = response.data;
          console.log("checkSessionForUser");
          console.log(result);
          if (result.res === 1) {
            Cookies.set("deviceSessionToken", result.session_token);
            Cookies.set("deviceSessionId", result.sessionId);
            var redirectUrl = Cookies.get("redirectUrl");
            Cookies.remove("redirectUrl");
            if (redirectUrl === null) {
              location.href = "/dashboard";
            } else {
              location.href = redirectUrl;
            }
          } else {
            $("#fail-login").text(result.msg);
            $("#fail-login").show();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getLogo: function () {
      this.axios
        .post(Config.API_URL + "/api/company-logo", {
          url: document.location.origin,
          type: "front",
        })
        .then((response) => {
          var result = response.data.data;
          this.logo_url = result.logo_image;
          this.login_side_background_img = result.background_image;
          this.highlight_color = result.highlight_color;
          this.organization_slogan = result.org_slogan;
          this.welcome_note = result.org_welcome_note;
          this.web_site_url = result.website;
          document.documentElement.style.setProperty(
            "--highlight-color",
            this.highlight_color
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    logoutFromMobileApp: function (appos, message) {
      try {
        if (appos === "ios") {
          if (window.webkit) {
            window.webkit.messageHandlers.logout.postMessage(message);
          }
        } else if (appos === "android") {
          Android.logout(message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    switchVisibility() {
      this.displayPasswordText = !this.displayPasswordText;
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
  },
};
export default Login;
</script>

<style scoped lang="scss">
@import "../assets/scss/component/login/login_new.scss";

// #submit_success {
//   color: #39c9ac !important;
// }

.alert {
  position: relative !important;
  padding: 0.75rem 1.25rem !important;
  margin-bottom: 1rem !important;
  border: 1px solid transparent !important;
  border-radius: 0.25rem !important;
  box-shadow: none !important;
}

.alert-success {
  color: #155724 !important;
  background-color: #d4edda !important;
  border-color: #c3e6cb !important;
}

.alert-danger {
  color: #943213 !important;
  background-color: #fdddd2 !important;
  border-color: #fdcbbc !important;
}

// .alert-success:not(.m-alert--outline) {
//   color: #21d055 !important;
//   border-color: #21d055;
//   border-bottom: solid 3px #21d055 !important;
//   font-weight: 500 !important;
//   background-color: #fff !important;
//   box-shadow: 0 5px 10px 2px rgba(52, 191, 163, 0.19) !important;
// }

// .alert-danger:not(.m-alert--outline) {
//   color: red !important;
//   border-color: red !important;
//   border-bottom: solid 3px red !important;
//   border-radius: 5px !important;
//   font-weight: 500 !important;
//   background-color: #fff !important;
//   box-shadow: 0 5px 10px 2px rgba(244, 81, 108, 0.36) !important;
// }
</style>
